// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__Cn_ZG","boxTitle":"Qualiphy_boxTitle__2wt2R","box":"Qualiphy_box__1EKAb","toggleWrap":"Qualiphy_toggleWrap__1Zf1d"};